import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useEffect, useMemo, useState, } from 'react';
import { Box, FormControlLabel, LinearProgress, Switch } from '@mui/material';
import { useAction, useAppSelector } from 'shared/hooks/redux/hooks';
import { setExternalPanel } from 'console/redux/z3k-custom-command/actions';
import { LegacyDevice } from 'console/device/device';
import { Capability } from 'console/device/device-capability';
import { ErrorBoundary } from 'shared/components/error-boundary';
import { BoilerAdapter } from 'z3k-config';
import { createSubsetSelector } from 'webui/utils/selectors';
import { useZ3KDeviceState } from 'console/shared/hooks/device/z3k';
import { useDeviceConfig } from 'console/shared/contexts/device/config';
import { selectDevice } from 'entities/device/lib';
import { useBooleanState } from 'shared/hooks/state/boolean';
function ExternalPanelImpl(props) {
    const { device } = props;
    const z3k_state = useZ3KDeviceState();
    const { z3k_config } = useDeviceConfig();
    const boiler_adapter_with_ext_panel = useMemo(() => BoilerAdapter.get.one(z3k_config, BoilerAdapter.isExternalPanel), [z3k_config]);
    const panel_state = useMemo(() => BoilerAdapter.isTurnOnExtPanel(boiler_adapter_with_ext_panel, z3k_state), [boiler_adapter_with_ext_panel, z3k_state]);
    const [ext_panel_on, changeExtPanel] = useState(panel_state);
    const [loading, noLoading, setLoading] = useBooleanState(false);
    useEffect(() => {
        changeExtPanel(panel_state);
        noLoading();
    }, [panel_state]);
    const _setExternalPanel = useAction(setExternalPanel);
    const onChangeExtPanel = useCallback((_, checked) => {
        if (boiler_adapter_with_ext_panel != null && device != null) {
            changeExtPanel(checked);
            _setExternalPanel(device.id, boiler_adapter_with_ext_panel.id, checked);
            setLoading();
        }
    }, [device, boiler_adapter_with_ext_panel, _setExternalPanel]);
    return device != null &&
        LegacyDevice.has_capability(device?.capabilities, Capability.has_external_panel) &&
        boiler_adapter_with_ext_panel != null ? (_jsx(ErrorBoundary, { children: _jsxs(Box, { mt: 1, display: "flex", alignItems: "center", flexDirection: "column", children: [_jsx(FormControlLabel, { onChange: onChangeExtPanel, control: _jsx(Switch, { checked: ext_panel_on, name: "switcher", color: "primary", disabled: !device.online }), label: "\u0412\u043D\u0435\u0448\u043D\u044F\u044F \u043F\u0430\u043D\u0435\u043B\u044C" }), loading && (_jsx(Box, { width: 210, children: _jsx(LinearProgress, {}) }))] }) })) : null;
}
const deviceSelector = createSubsetSelector(['id', 'capabilities', 'online']);
export const Z3KExternalPanel = memo(function Z3KExternalPanel(props) {
    const { device_id, ...rest } = props;
    const device = useAppSelector((state) => deviceSelector(selectDevice(state, device_id)));
    if (!device) {
        return null;
    }
    return _jsx(ExternalPanelImpl, { device: device, ...rest });
});
